/** Saves CSV text returned by an export endpoint as a file */
export const downloadCsv = (csv: string, filename: string) => {
  const blob = new Blob([ csv ], { type: 'text/csv;charset=utf-8' });
  const url = window.URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = filename;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  window.URL.revokeObjectURL(url);
};
